const STANDARD_HERO_FIELDS = ['heroImgUrl', 'heroImageLinkUrl']

export function getTemplateHeroFields(templateKey = 'default') {
  return STANDARD_HERO_FIELDS
}

export function usesAnimatedHeroImage(templateKey = 'default') {
  return false
}

export function resolveTemplateHeroImages(variables = {}, templateKey = 'default') {
  return { ...variables }
}

export function syncTemplateHeroImageUpdate(property, value, templateKey = 'default') {
  return { [property]: value }
}

export default getTemplateHeroFields
